import {defineRouting} from 'next-intl/routing';

export const routing = defineRouting({
  locales: ['no', 'en', 'de', 'fr', 'zh'],
  defaultLocale: 'no'
});
